import { init } from "@nosto/preact"
import { Serp, Category, Autocomplete, History } from "./components"
import { defaultConfig } from "./config"
import { formatSearchInput } from './searchinput'
import "./styles/index.css"

formatSearchInput().then(res => {
    if(res.success) {
        init({
            ...window.nostoTemplatesConfig,
            serpComponent: Serp,
            historyComponent: History,
            autocompleteComponent: Autocomplete,
            categoryComponent: Category,
            formCssSelector: '.nosto-search-form',
            inputCssSelector: '#nosto-search-input',
            contentCssSelector: '#main',
            serpUrlMapping: {
                query: 'q',
            },
            serpPath: '/search',
            serpQuery: {
                products: {
                    // fields: [
                    //     'productId', 'url', 'name', 'imageUrl', 'thumbUrl', 'description', 'brand',
                    //     'availability', 'price', 'priceText', 'listPrice', 'ratingValue', 'reviewCount',
                    //     'customFields.key', 'customFields.value'
                    // ],
                    facets: ['*'],
                    size: defaultConfig.serpSize,
                    from: 0,
                },
            },
            autocompleteQuery: {
                products: {
                    // fields: [
                    //     'productId', 'url', 'name', 'imageUrl', 'thumbUrl', 'brand',
                    //     'availability', 'price', 'priceText', 'listPrice', 'ratingValue', 'reviewCount'
                    // ],
                    size: defaultConfig.autocompleteSize,
                },
                keywords: {
                    fields: [
                        'keyword', '_highlight.keyword'
                    ],
                    size: defaultConfig.keywordsSize,
                },
            },
            // Uncomment for Category Merchandising
            categoryCssSelector: '.shopify-section--main-collection section',
            isCategoryPage: () => location.pathname.startsWith('/collections') || document.querySelector('.nosto_page_type')?.textContent === 'category',
            categoryQuery: () => {
                if(document.querySelector('.nosto_category')) {
                    return {
                        name: 'serp',
                        products: {
                            categoryPath: document.querySelector('.nosto_category > .category_string')?.textContent,
                            categoryId: document.querySelector('.nosto_category > .id')?.textContent,
                            size: defaultConfig.serpSize,
                            from: 0,
                        }
                    }
                }
            },
            compressUrlParameters: true,
            fallback: true
        })
    }
})
